var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svgİcon10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.2818 12.8413L34.1602 4.70419V37.312H45.0293V19.4482C45.0293 16.9678 44.0402 14.5899 42.2818 12.8413Z",
    fill: "#FFB782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.34814 31.3705L0.208314 15.4314C-0.407926 13.8314 0.389264 12.0341 1.99018 11.4175L30.9701 0.254793C32.5701 -0.361448 34.3675 0.435743 34.9837 2.03666L41.1235 17.9757C41.7398 19.5757 40.9426 21.3731 39.3417 21.9896L10.3626 33.1523C8.7617 33.7686 6.96527 32.9705 6.34814 31.3705Z",
    fill: "#DE4C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1967 7.77856L2.44922 21.2473L4.76294 27.2534L39.5119 13.7909L37.1967 7.77856Z",
    fill: "#7A4930"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 20.2317V3.1514C0 1.43639 1.39055 0.0458374 3.10557 0.0458374H34.1606C35.8757 0.0458374 37.2662 1.43639 37.2662 3.1514V20.2317C37.2662 21.9467 35.8757 23.3373 34.1606 23.3373H3.10557C1.39055 23.3373 0 21.9467 0 20.2317Z",
    fill: "#4398D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1614 0.0458374H30.8618L7.57031 23.3373H34.1614C35.8764 23.3373 37.2669 21.9467 37.2669 20.2317V3.1514C37.2669 1.43639 35.8764 0.0458374 34.1614 0.0458374Z",
    fill: "#3E8CC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.10547 12.4678H6.21104V14.0206H3.10547V12.4678Z",
    fill: "#5EB3D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.10547 17.1262H6.21104V18.6789H3.10547V17.1262Z",
    fill: "#5EB3D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0801 17.1262H20.1856V18.6789H17.0801V17.1262Z",
    fill: "#5EB3D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.76367 12.4678H10.8689V14.0206H7.76367V12.4678Z",
    fill: "#5EB3D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4219 12.4678H15.5274V14.0206H12.4219V12.4678Z",
    fill: "#5EB3D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0801 12.4678H20.1856V14.0206H17.0801V12.4678Z",
    fill: "#5EB3D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.832 3.1514H33.3848V5.48057H31.832V3.1514Z",
    fill: "#5EB3D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7266 3.1514H30.2793V5.48057H28.7266V3.1514Z",
    fill: "#5EB3D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6211 3.1514H27.1739V5.48057H25.6211V3.1514Z",
    fill: "#5EB3D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5156 3.1514H24.0681V5.48057H22.5156V3.1514Z",
    fill: "#5EB3D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0547 37.312H45.0294V45.0756H31.0547V37.312Z",
    fill: "#88B337"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7765 14.0711C27.4596 12.759 25.3286 12.7629 24.0165 14.0797C22.7478 15.3529 22.7038 17.3986 23.9164 18.7256L30.2787 25.6665C28.3664 29.0133 28.4481 33.1404 30.4906 36.4091L31.0551 37.312H41.1479V26.4429L28.7765 14.0711Z",
    fill: "#FFB782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3848 39.6412H34.9376V41.194H33.3848V39.6412Z",
    fill: "#6B962A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.10547 8.12025V4.39368C3.10547 3.70732 3.66139 3.1514 4.34775 3.1514H8.07432C8.76068 3.1514 9.31631 3.70732 9.31631 4.39368V8.12025C9.31631 8.80661 8.76068 9.36253 8.07432 9.36253H4.34775C3.66139 9.36253 3.10547 8.80661 3.10547 8.12025Z",
    fill: "#FDB62F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.10547 5.48059H5.43464V7.03338H3.10547V5.48059Z",
    fill: "#FD7B2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.98828 5.48059H9.31716V7.03338H6.98828V5.48059Z",
    fill: "#FD7B2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3723 26.4429C40.1667 26.4429 39.9688 26.3611 39.8235 26.2153L36.718 23.1097C36.4199 22.8016 36.4286 22.3101 36.7376 22.0118C37.0388 21.7215 37.5154 21.7215 37.8158 22.0118L40.9214 25.1174C41.2242 25.421 41.2242 25.9125 40.9214 26.2153C40.7752 26.3611 40.5782 26.4429 40.3723 26.4429Z",
    fill: "#F2A46F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svgİcon10);
export default __webpack_public_path__ + "static/media/icon-10.8357fdea4140a51b28f9cbb825409d75.svg";
export { ForwardRef as ReactComponent };